import { render } from "./MigrateTenant.vue?vue&type=template&id=2aceb260&scoped=true"
import script from "./MigrateTenant.vue?vue&type=script&lang=js"
export * from "./MigrateTenant.vue?vue&type=script&lang=js"

import "./MigrateTenant.vue?vue&type=style&index=0&id=2aceb260&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aceb260"]])

export default __exports__